import "./Disease.module.css";
import Header from "@/reusable_sections/Header";
import HealthAwarenessHero from "./sections/HealthAwarenessHero";
import DiseaseAwarenessGrid from "./sections/DiseaseAwarenessGrid";
import Footer from "@/reusable_sections/Footer";
export default function DiseasePage() {
  return <div>
      <Header />
      <HealthAwarenessHero />
      <DiseaseAwarenessGrid />
      <Footer />
    </div>;
}